"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var DelinquencyStatusTable = /** @class */ (function (_super) {
    __extends(DelinquencyStatusTable, _super);
    function DelinquencyStatusTable(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        return _this;
    }
    DelinquencyStatusTable.prototype.render = function () {
        if (this.props.loading) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            if (this.props.delinquency) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "row mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "table-responsive panel-border px-4", children: [(0, jsx_runtime_1.jsx)("b", { className: "pl-1", children: "Delinquency status" }), (0, jsx_runtime_1.jsx)("table", { className: "table table-hover table-sm table-borderless mt-3", children: (0, jsx_runtime_1.jsxs)("tbody", { children: [(0, jsx_runtime_1.jsx)("tr", { className: "pb-0", children: (0, jsx_runtime_1.jsxs)("td", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Delinquency start date:" }), " ", this.supportPortalTemplates.convertDate(this.props.delinquency.startDate, "DD/MM/YYYY")] }) }), (0, jsx_runtime_1.jsx)("tr", { className: "pb-0", children: (0, jsx_runtime_1.jsxs)("td", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Delinquency type:" }), " ", this.props.delinquency.type] }) }), (0, jsx_runtime_1.jsx)("tr", { className: "pb-0", children: (0, jsx_runtime_1.jsxs)("td", { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Delinquency status:" }), " ", this.props.delinquency.status] }) })] }) })] }) }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("h3", { className: "panel-border px-4", children: "Delinquency not found!" });
            }
        }
    };
    DelinquencyStatusTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DelinquencyStatusTable);
    return DelinquencyStatusTable;
}(React.Component));
exports.default = DelinquencyStatusTable;
//# sourceMappingURL=DelinquencyStatusTable.js.map